import { RiSparklingLine } from '@remixicon/react';
import { WELCOME_SUGGESTIONS } from '../constants.js';

interface WelcomeScreenProps {
  onSend?: (text: string) => void;
  appContext?: 'crm' | 'prospecting';
}

export function WelcomeScreen({ onSend, appContext }: WelcomeScreenProps) {
  const prompts = WELCOME_SUGGESTIONS[appContext ?? 'default'] ?? WELCOME_SUGGESTIONS.default;

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-6">
      <RiSparklingLine className="h-8 w-8 text-primary" />
      <p className="text-sm text-muted-foreground">How can I help you today?</p>
      <div className="flex flex-wrap justify-center gap-2 max-w-md">
        {prompts.map((prompt) => (
          <button
            key={prompt}
            type="button"
            onClick={() => onSend?.(prompt)}
            className="rounded-full border border-border bg-background px-3 py-1.5 text-xs text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
}
